import { FC, useState } from "react";
import {
  DialogActions,
  Button,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText
} from "@mui/material";

type Props = {
  title: string;
  onClose: () => void;
  onSave: () => void;
  onComplete: () => void;
  canComplete: boolean;
  isSaving?: boolean;
  /** Drops Save and Complete but keeps Close, so a read-only viewer can still dismiss. */
  readOnly?: boolean;
};

export const DialogFooterActions: FC<Props> = ({
  title,
  onClose,
  onSave,
  onComplete,
  canComplete,
  isSaving = false,
  readOnly = false
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleConfirmComplete = () => {
    setConfirmOpen(false);
    onComplete();
  };

  return (
    <DialogActions sx={{ borderTop: "1px solid", borderColor: "divider" }}>
      <Box
        display="flex"
        justifyContent="space-between"
        width="100%"
        alignItems="center"
      >
        <Box flex={1}>
          <Button variant="text" onClick={onClose}>
            <Typography variant="button" lineHeight={1} color="text.secondary">
              Close
            </Typography>
          </Button>
        </Box>
        {!readOnly && (
          <Box width={190} display="flex" justifyContent="space-between">
            <Button loading={isSaving} variant="text" onClick={onSave}>
              Save
            </Button>
            <Button
              variant="contained"
              disabled={!canComplete}
              onClick={() => setConfirmOpen(true)}
            >
              Complete
            </Button>
          </Box>
        )}
      </Box>

      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Typography variant="h6" component="span">
            Complete {title} lifecycle?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            This marks the {title} lifecycle as completed. Are you sure you want
            to continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={() => setConfirmOpen(false)}>
            <Typography variant="button" lineHeight={1} color="text.secondary">
              Cancel
            </Typography>
          </Button>
          <Button
            variant="contained"
            loading={isSaving}
            onClick={handleConfirmComplete}
          >
            Complete
          </Button>
        </DialogActions>
      </Dialog>
    </DialogActions>
  );
};
